
import { defineComponent, computed, PropType, onMounted } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import { useForm } from 'vee-validate'
import { KariirekinUiItem } from '@/views/fuzoku-meisai/kaikei-kijun/data'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'

type InputForm = {
  itemName: string;
  interestRate: number;
  repaymentDeadline: string;
}

const validationSchema = object({
  itemName: myValidationSchemaObj.maxString(20),
  interestRate: myValidationSchemaObj.requiredPositiveNum,
  repaymentDeadline: myValidationSchemaObj.requiredDate
})

export default defineComponent({
  components: {
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<KariirekinUiItem>,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    upItem: (item: KariirekinUiItem) => true,
    downItem: (item: KariirekinUiItem) => true,
    trashItem: (item: KariirekinUiItem) => true,
    changeInput: (item: KariirekinUiItem) => true
  },
  setup (props, { emit }) {
    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      initialValues: {
        itemName: props.item.item.itemName,
        interestRate: props.item.item.interestRate,
        repaymentDeadline: props.item.item.repaymentDeadline
      }
    })
    const headerName = computed(() => {
      if (!values.itemName) {
        return validationMessage.enterItem
      }
      return values.itemName
    })

    const onClickedUpItem = () => {
      emit('upItem', props.item)
    }

    const onClickedDownItem = () => {
      emit('downItem', props.item)
    }

    const onClickedTrashItem = () => {
      emit('trashItem', props.item)
    }

    const onChange = async () => {
      const item = props.item
      item.item.itemName = values.itemName
      item.item.interestRate = values.interestRate
      item.item.repaymentDeadline = values.repaymentDeadline
      await validate()
      item.isValid = meta.value.valid
      emit('changeInput', item)
    }

    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem = props.item
      propItem.item.settings = item
      emit('changeInput', propItem)
    }

    onMounted(async () => {
      await validate()
      const item = props.item
      item.isValid = meta.value.valid
      emit('changeInput', item)
    })

    return {
      headerName,
      errors,
      values,
      onClickedUpItem,
      onClickedDownItem,
      onClickedTrashItem,
      onChange,
      onUpdateKmk
    }
  }
})
